module.exports = __webpack_public_path__ + "static/media/10S.fcf90942.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/10S.svg
// module id = 36
// module chunks = 0